// Sélecteur de priorité (WKF-013) — retour PO 2026-07-07 : les chips ne doivent
// PAS être « quadrées » (un cadre autour d'une pastille = disgracieux). Ici, le
// chip EST le bouton : sélectionné = pleine couleur DS + anneau ; non sélectionné
// = contour neutre discret. Sémantique radiogroup + navigation flèches (a11y).

import { useTranslation } from 'react-i18next'

import type { Priority } from '@/hooks/useNotifications.types'
import { cn } from '@/lib/utils'

import { PRIORITY_CHIP, PRIORITY_CHIP_NORMAL } from './notification-config'

const PRIORITIES: Priority[] = ['NORMAL', 'HIGH', 'URGENT']

interface PrioritySelectProps {
    value: Priority
    onChange: (p: Priority) => void
}

export function PrioritySelect({ value, onChange }: PrioritySelectProps) {
    const { t } = useTranslation()

    const onKeyDown = (e: React.KeyboardEvent, index: number) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return
        e.preventDefault()
        const delta = e.key === 'ArrowRight' ? 1 : -1
        onChange(PRIORITIES[(index + delta + PRIORITIES.length) % PRIORITIES.length])
    }

    return (
        <div role="radiogroup" aria-label={t('notifications.task.priority', 'Priorité')} className="flex flex-wrap gap-2">
            {PRIORITIES.map((p, i) => {
                const cfg = p === 'NORMAL' ? PRIORITY_CHIP_NORMAL : PRIORITY_CHIP[p]!
                const selected = value === p
                return (
                    <button
                        key={p}
                        type="button"
                        role="radio"
                        aria-checked={selected}
                        tabIndex={selected ? 0 : -1}
                        onClick={() => onChange(p)}
                        onKeyDown={(e) => onKeyDown(e, i)}
                        className={cn(
                            'inline-flex h-8 items-center rounded-full px-3 text-xs font-medium transition-colors',
                            // Focus clavier UNIQUEMENT (invisible au clic souris) — pas d'anneau
                            // permanent teal sur la chip sélectionnée (retour PO : disgracieux).
                            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
                            // Sélection = couleur pleine de la chip (bordure de sa propre teinte),
                            // AUCUN anneau ; non sélectionné = contour neutre discret.
                            selected
                                ? cn(cfg.className, 'font-semibold')
                                : 'border border-input bg-transparent text-muted-foreground hover:bg-muted',
                        )}
                    >
                        {t(cfg.labelKey)}
                    </button>
                )
            })}
        </div>
    )
}
